import { useState } from "react";
import { Stethoscope, Calculator, Sparkles } from "lucide-react";
import { CoopSaluteCalc } from "@/components/CoopSaluteCalc";
import { CoopSaluteChat } from "@/components/CoopSaluteChat";

const TABS = [
  { key: "calc", label: "Calcolo preventivo", icon: Calculator },
  { key: "ai", label: "Assistente AI", icon: Sparkles },
];

export default function CoopSaluteQuote() {
  const [tab, setTab] = useState("calc");
  return (
    <div className="space-y-6" data-testid="coopsalute-page">
      <div>
        <div className="text-[11px] font-bold uppercase tracking-wider text-sector-red">Cooperazione Salute</div>
        <h1 className="mt-1 flex items-center gap-2 font-heading text-3xl font-semibold text-forest"><Stethoscope className="h-7 w-7" />Piani sanitari 4You</h1>
        <p className="mt-1 text-sm text-muted-foreground">Salute, Salute Famiglia, Sostegno e Sostegno Famiglia (Ed. 01/2026), con piano dei versamenti e detrazione 19%.</p>
      </div>
      <div className="flex gap-2">
        {TABS.map((t) => (
          <button key={t.key} onClick={() => setTab(t.key)} data-testid={`cs-tab-${t.key}`}
            className={`inline-flex items-center gap-2 rounded-full border px-4 py-2 text-xs font-semibold uppercase tracking-wide transition-colors ${tab === t.key ? "border-forest bg-forest text-white" : "border-forest/30 text-forest hover:bg-sage"}`}>
            <t.icon className="h-4 w-4" />{t.label}
          </button>
        ))}
      </div>
      {tab === "calc" ? <CoopSaluteCalc /> : <CoopSaluteChat />}
    </div>
  );
}
